import { render, staticRenderFns } from "./StoreNotFound.vue?vue&type=template&id=2bb6c4e4&lang=html"
import script from "./StoreNotFound.vue?vue&type=script&lang=js"
export * from "./StoreNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports